import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { searchType } from '../../store/searchStore';
import { isNullOrUndefined } from '../../store/storeFunctions';

import '../../css/common/reportLinksButtons.scss'

class SearchLinkButton extends React.Component {
    render() {
        if (isNullOrUndefined(this.props.query))
            return null;

        const openNewWindow = this.props.openNewWindow === true;
        return (
            <span
                className={classnames('report-links', { 'report-links-column': this.props.column })}
                onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}
            >
                {this.renderLink(`/search/results?type=${encodeURIComponent(searchType.BS)}&q=${encodeURIComponent(this.props.query)}`,
                    'Links.Search', openNewWindow, true, this.props.translate, this.props.extraClass || '', this.props.useShort || false)}
            </span>
        )
    }

    renderLink = (url, translationKey, openNewWindow, includeTooltips, translate, extraClass, useShort = false) => {
        let translation = translate(`${translationKey}.Description`);
        if (localStorage.getItem('locales_report_buttons_format') === 'short') {
            translation = translate(`${translationKey}.ExtraShort`);
        } else if (useShort) {
            translation = translate(`${translationKey}.Short`);
        }

        return (
            <Link key={translationKey}
                className={classnames(`report-link ${extraClass || ''}`.trim(), { 'is-square': localStorage.locales_button_style === 'square' })}
                to={url} title={includeTooltips ? translate(`${translationKey}.Description`).replace(/<\/?[^>]+(>|$)/g, "") : ""} target={openNewWindow ? "_blank" : null}
            >
                {ReactHtmlParser(translation)}
            </Link>
        )
    }
}

export default withLocalize(SearchLinkButton);